import React from "react";
import { Outlet } from "react-router-dom";
import { GsdStandaloneModuleLayout } from "@/coquille-bridge";
import { AdminGuard } from "@/components/admin/AdminGuard.jsx";
import {
  mapDocumentsPreuvesItemsToTabs,
  renderDocumentsPreuvesNavLink,
} from "@/pages/documentsPreuves/DocumentsPreuvesSubNav.jsx";
import {
  ADMIN_DOCUMENTS_PREUVES_BASE,
  DOCUMENTS_PREUVES_MODULE_EN,
  DOCUMENTS_PREUVES_MODULE_FR,
  DOCUMENTS_PREUVES_SUB_NAV,
} from "@/pages/documentsPreuves/documentsPreuvesNavConfig.js";
import { useI18n } from "@/coquille-bridge";

function useLocale() {
  const { lang } = useI18n();
  return lang === "en" ? "en" : "fr";
}

export function DocumentsPreuvesAdminLayout() {
  const locale = useLocale();
  return (
    <AdminGuard>
      <GsdStandaloneModuleLayout
        title={{ labelFr: DOCUMENTS_PREUVES_MODULE_FR, labelEn: DOCUMENTS_PREUVES_MODULE_EN }}
        basePath={ADMIN_DOCUMENTS_PREUVES_BASE}
        tabs={mapDocumentsPreuvesItemsToTabs(DOCUMENTS_PREUVES_SUB_NAV)}
        lang={locale}
        moduleTestId="documents-preuves-admin-module"
        testId="gsd-documents-preuves-module-layout"
        subNavTestId="documents-preuves-subnav"
        renderTabLink={renderDocumentsPreuvesNavLink}
      >
        <Outlet />
      </GsdStandaloneModuleLayout>
    </AdminGuard>
  );
}
